// extracted by mini-css-extract-plugin
export var animateDesktopStickyNav = "Navigation-module--animateDesktopStickyNav--40f03";
export var backToTop = "Navigation-module--backToTop--edab5";
export var callToAction = "Navigation-module--callToAction--0cc47";
export var contact = "Navigation-module--contact--f2d4c";
export var darkNav = "Navigation-module--darkNav--02ba5";
export var desktopLink = "Navigation-module--desktopLink--faa38";
export var desktopStickyNav = "Navigation-module--desktopStickyNav--d0831";
export var details = "Navigation-module--details--bb241";
export var dropDown = "Navigation-module--dropDown--f6d9a";
export var dropDownOpen = "Navigation-module--dropDownOpen--aa474";
export var imgContainer = "Navigation-module--imgContainer--c7eb6";
export var logoContainer = "Navigation-module--logoContainer--de40c";
export var mainSection = "Navigation-module--mainSection--8cffb";
export var majorLinks = "Navigation-module--majorLinks--94b54";
export var minorLinks = "Navigation-module--minorLinks--cff73";
export var mobileCallToAction = "Navigation-module--mobileCallToAction--43f8f";
export var mobileNav = "Navigation-module--mobileNav--0e154";
export var mobileNavTrigger = "Navigation-module--mobileNavTrigger--120d6";
export var navigation = "Navigation-module--navigation--556af";
export var slideInDropDown = "Navigation-module--slideInDropDown--86e75";
export var socialLinks = "Navigation-module--socialLinks--834ab";
export var topSection = "Navigation-module--topSection--ade4b";
export var veilOfDarkness = "Navigation-module--veilOfDarkness--5d9f2";